module.exports = __webpack_public_path__ + "img/newppipad.35e7a740.png";